import React from 'react';

export default  function SuggestedWords({words}){
    return ( 
        <span  className="badge customized-badge rounded-border even-larger-badge " >Suggested Words: {words} </span>
    )
      
      
}